import * as React from 'react';
import {Button, Divider, Input, Menu, message, Modal, Typography} from 'antd';
import QuickRouter from '../../utils/QuickRouter';
import useAuth from '../../utils/AuthContext';
import UseUser, {UserType} from '../../hooks/apis/useUser';
import {useInput, useBoolean} from 'react-hanger';
import Flex from '../Flex';
import useQuickRouter from '../../utils/QuickRouter';
import CommonApiErrorHandler from '../../utils/HttpInstance';

const {Text} = Typography;
const {SubMenu} = Menu;
const {Search} = Input;

function PageHeader() {
  const auth = useAuth();
  const isUpdatePassword = useBoolean(false);
  const passwordMd5 = useInput('');
  const updatePassword = UseUser.updatePassword();
  const quickRouter = useQuickRouter();
  return (
    <React.Fragment>
      <div className="pageHeader">
        <div className="titleWrapper">
          <Flex className={'titleContainer'}>
            <div onClick={quickRouter.index} style={{cursor: 'pointer'}}>
              <h1>上海市宇航学会科普活动网络平台</h1>
              <small>Youth Science Activity Network Platform</small>
            </div>
            <div className={'titleFloat'}>宇航学会</div>
            <div style={{paddingRight: 20, zIndex: 20, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', justifyContent: 'flex-end'}}>
              {auth.currentUser ? (
                <div>
                  {auth.currentUser.type == UserType.管理员 && (
                    <React.Fragment>
                      <a onClick={quickRouter.manageContestList}>活动管理</a>
                      <Divider type={'vertical'} />
                      <a onClick={quickRouter.manageKnowledgeBankList}>题目数据库</a>
                      <Divider type={'vertical'} />
                      <a onClick={quickRouter.manageUserList}>用户列表</a>
                      <Divider type={'vertical'} />
                      <a onClick={quickRouter.manageSystem}>系统设置</a>
                      <Divider type={'vertical'} />
                    </React.Fragment>
                  )}
                  <a onClick={quickRouter.userProfile}>个人信息</a>
                  <Divider type={'vertical'} />
                  <a onClick={isUpdatePassword.setTrue}>修改密码</a>
                  <Divider type={'vertical'} />
                  <a
                    onClick={() => {
                      auth.logout();
                      localStorage.removeItem('Application-Token');
                    }}>
                    注销
                  </a>
                </div>
              ) : (
                <div>
                  <a onClick={quickRouter.register}>新用户注册</a>
                  <Divider type={'vertical'} />
                  <a onClick={quickRouter.login}>登录</a>
                </div>
              )}
            </div>
          </Flex>
        </div>
      </div>
      <Modal title={'修改密码'} visible={isUpdatePassword.value} onCancel={isUpdatePassword.setFalse} footer={false}>
        <Text>请输入新密码</Text>
        <Input.Password className={'mt-md mb-md'} placeholder={'请输入新密码'} {...passwordMd5.eventBind} />
        <Button
          loading={updatePassword.loading}
          onClick={() =>
            updatePassword
              .request({passwordMd5: passwordMd5.value})
              .then(() => {
                message.success('修改成功');
                isUpdatePassword.setFalse();
              })
              .catch(CommonApiErrorHandler)
          }>
          确认
        </Button>
      </Modal>
    </React.Fragment>
  );
}
export default PageHeader;
